export default "__VITE_ASSET__CKUittrb__"